import React from 'react';

const benefits = [
  {
    title: 'Effortless Comfort & Convenience',
    description: 'No more waiting rooms or commutes. We bring the complete salon experience to your doorstep—on your schedule, in your sanctuary.'
  },
  {
    title: 'Clinical Hygiene & Expert Care',
    description: 'Our vetted professionals follow rigorous hygiene protocols using premium products and fresh, one-time sheets for your absolute safety.'
  },
  {
    title: 'Personalized Beauty Rituals',
    description: 'Every skin type is unique. We customize our techniques and products to ensure a gentle, effective experience tailored specifically to you.'
  }
];

const Benefits = () => {
  return (
    <section id="benefits" className="benefits section">
      <div className="container">
        <h2>Why Choose Glaminant?</h2>
        <div className="benefit-grid">
          {benefits.map((item, index) => (
            <div className="benefit-card" key={index}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;